import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/all.css"
import "./App.css";
import MainCompo from "./components/MainCompo";

function App() {
  return <MainCompo />;
}

export default App;
